<template>
  <div class="DealerHeader" :class="brandInfo.currentBrand == 2 ? 'DealerHeader--teboil' : 'DealerHeader--lukoil'">
    <!-- Модальное окно для выбора бренда -->
    <dialog v-if="brandInfo.brand === 3" ref="brandModal" class="brand-modal" @click="handleBackdropClick">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>Выберите бренд</h3>
          <button class="close-button" @click="closeModal">
            <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px">
              <title/>
              <g id="cross">
                <line fill="none" stroke="#545454" stroke-linecap="round" stroke-linejoin="round" stroke-width="2px" x1="7" x2="25" y1="7" y2="25"/>
                <line fill="none" stroke="#545454" stroke-linecap="round" stroke-linejoin="round" stroke-width="2px" x1="7" x2="25" y1="25" y2="7"/>
              </g>
            </svg>
          </button>
        </div>
        <div class="modal-body">
          <div class="switch-dealer-type">
            <button @click="switchDealerBrand(1)" class="brand-button" title="ЛУКОЙЛ">
              <img src="@/assets/images/modal-logo/luk.png" alt="Лукойл" />
            </button>
            <button @click="switchDealerBrand(2)" class="brand-button" title="TEBOIL">
              <img src="@/assets/images/modal-logo/tb.png" alt="Teboil" />
            </button>
          </div>
        </div>
      </div>
    </dialog>

    <div class="nav-wrapper">
      <div class="container p-0">
        <nav class="navbar navbar-expand-md navbar-light bg-ligh">
          <button
              ref="navbarToggler"
              class="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarNavDropdown"
              aria-controls="navbarNavDropdown"
              aria-expanded="false"
              aria-label="Toggle navigation"
          >
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <router-link class="navbar-brand" :to="{ name: 'Home' }">
            <img v-if="brandInfo.currentBrand == 2" src="@/assets/images/logo-teb.svg" class="logo header-logo-img" alt="Teboil" />
            <img v-else src="@/assets/images/logo.png" class="logo header-logo-img" alt="Лукойл" />
          </router-link>

          <div class="collapse" ref="mobileMenu" id="navbarNavDropdown">
            <ul class="menu-mobile">
              <template v-if="availablePage">
                <li
                    @click="collapseMenu"
                    class="menu-item"
                    v-for="item in sectionsList"
                    :key="item.name"
                >
                  <router-link :to="/catalog/ + item.slug">{{
                      item.name
                    }}</router-link>
                </li>
              </template>
              <li @click="collapseMenu" class="menu-item" v-if="brandInfo.currentBrand === 1">
                <static-page
                    class="sub-menu__item-link"
                    title="Обучение"
                    slug="/education"
                />
              </li>
              <li v-if="availablePage && brandInfo.currentBrand === 1" @click="collapseMenu" class="menu-item">
                <static-page
                    class="sub-menu__item-link"
                    type="4"
                    slug="/visits"
                />
              </li>
              <li @click="collapseMenu" class="menu-item">
                <static-page type="1" slug="/delivery" />
              </li>
              <li @click="collapseMenu" class="menu-item">
                <static-page type="2" slug="/how-to-order" />
              </li>
              <li @click="collapseMenu" class="menu-item">
                <router-link to="/profile">Личный кабинет</router-link>
              </li>
              <li @click="collapseMenu" class="menu-item">
                <static-page type="3" slug="/about" />
              </li>
            </ul>
          </div>
          <div class="navbar-collapse">
            <div class="ml-auto d-none d-lg-block" v-if="brandInfo.currentBrand == 2">
              <span class="DealerHeaderText--teboil">Дилерский портал для заказа маркетинговой продукции</span>
            </div>
            <div class="ml-auto d-none d-lg-block" v-else>
<!--              <img src="@/assets/images/dealer-cup.svg" alt="cup" width="258" />-->
              <span class="DealerHeaderText--lukoil">Дилерский портал для заказа маркетинговой продукции</span>
            </div>
            <!-- Кнопка для открытия модального окна -->
            <div class="brand-switcher">
<!--              <button v-if="brandInfo.brand == 3" @click="switchDealerBrand(brandInfo.currentBrand == 1 ? 2 : 1)" class="brand-switcher-button">-->
<!--                {{ getAlternativeBrandName() }}-->
<!--              </button>-->
              <div class="brand-switche-containerr" v-if="brandInfo.brand == 3">
                <div v-if="brandInfo.currentBrand == 2 || brandInfo.currentBrand == 3" class="brand-switcher-wrapper">
<!--                  <span class="brand-switcher-wrapper-title brand-switcher-wrapper-title&#45;&#45;lukoil">Лукмаркет</span>-->
                  <button @click="switchDealerBrand(1)" class="brand-switcher-logo-btn brand-switcher-logo-btn--lukoil" title="ЛУКОЙЛ">
                    <img src="@/assets/images/luk_CM_logo_rus.svg" alt="ЛУКОЙЛ" />
                  </button>
                </div>
                <div v-else-if="brandInfo.currentBrand == 1 || brandInfo.currentBrand == 3" class="brand-switcher-wrapper">
<!--                  <span class="brand-switcher-wrapper-title brand-switcher-wrapper-title&#45;&#45;teboil">Лукмаркет</span>-->
                  <button @click="switchDealerBrand(2)" class="brand-switcher-logo-btn brand-switcher-logo-btn--teboil" title="TEBOIL">
                    <img src="@/assets/images/logo-teb.svg" alt="TEBOIL" />
                  </button>
                </div>
              </div>
            </div>
            <ul class="navbar-nav ml-auto flex-end-sm">
              <li class="nav-item">
                <span class="ooo">{{ accountInfo.name }}</span>
                <span class="coins">Баланс: {{ pointsNumber }} балл</span>
              </li>
              <li class="nav-item bag">
                <router-link
                    :to="{ name: 'DealerCart' }"
                    class="nav-link"
                    :data-count="itemsInCart"
                >
                  <span class="itemsTooltip">Корзина</span>
                  <svg viewBox="0 0 24 24" width="24px" height="24px">
                    <g
                        id="404"
                        fill="none"
                        fill-rule="evenodd"
                        stroke="none"
                        stroke-width="1"
                        transform="translate(-977 -22)"
                    >
                      <g id="Group-8" fill="#ffffff" fill-rule="nonzero">
                        <g id="Group-4" transform="translate(977 22)">
                          <g id="bag">
                            <path
                                id="Shape"
                                d="M 21.1925 6.28424 C 21.1306 5.8708 20.7796 5.5814 20.3668 5.5814 L 15.6188 5.5814 L 15.6188 3.63824 C 15.6188 1.63307 13.988 0 11.9855 0 C 9.98314 0 8.35231 1.63307 8.35231 3.63824 L 8.35231 5.5814 L 3.60434 5.5814 C 3.19147 5.5814 2.84053 5.8708 2.7786 6.28424 L 0.012386 23.0284 C -0.0289007 23.2765 0.0330294 23.5245 0.198177 23.7106 C 0.363324 23.8966 0.590401 24 0.838121 24 L 23.133 24 C 23.133 24 23.133 24 23.1536 24 C 23.6284 24 24 23.6279 24 23.1525 C 24 23.0491 23.9794 22.9664 23.9587 22.8837 L 21.1925 6.28424 Z M 10.0451 3.63824 C 10.0451 2.56331 10.9121 1.69509 11.9855 1.69509 C 13.059 1.69509 13.926 2.56331 13.926 3.63824 L 13.926 5.5814 L 10.0451 5.5814 L 10.0451 3.63824 Z M 1.829 22.3256 L 4.32685 7.27649 L 8.35231 7.27649 L 8.35231 12.0103 C 8.35231 12.4858 8.7239 12.8579 9.19869 12.8579 C 9.67349 12.8579 10.0451 12.4858 10.0451 12.0103 L 10.0451 7.27649 L 13.926 7.27649 L 13.926 12.0103 C 13.926 12.4858 14.2976 12.8579 14.7724 12.8579 C 15.2472 12.8579 15.6188 12.4858 15.6188 12.0103 L 15.6188 7.27649 L 19.6442 7.27649 L 22.1421 22.3256 L 1.829 22.3256 Z"
                            ></path>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </router-link>
              </li>
              <li class="nav-item">
                <a @click="logout" class="nav-link" role="button">
                  <span class="logoutTooltip">Выход</span>
                  <svg viewBox="0 0 24 24" width="24px" height="24px">
                    <g
                        id="404"
                        fill="none"
                        fill-rule="evenodd"
                        stroke="none"
                        stroke-width="1"
                        transform="translate(-1031 -22)"
                    >
                      <g id="Group-8" fill="#ffffff" fill-rule="nonzero">
                        <g id="logout" transform="translate(1031 22)">
                          <path
                              id="Shape"
                              d="M 16.9436 18.1333 C 17.1077 18.2974 17.3128 18.3795 17.5385 18.3795 C 17.7641 18.3795 17.9692 18.2974 18.1333 18.1333 L 23.6718 12.5949 C 23.7128 12.5538 23.7538 12.5128 23.7744 12.4718 C 23.7744 12.4718 23.7949 12.4513 23.7949 12.4308 C 23.8154 12.3897 23.8359 12.3487 23.8564 12.3282 C 23.8564 12.3077 23.8564 12.2872 23.8769 12.2872 C 23.8974 12.2462 23.8974 12.2256 23.9179 12.1846 C 23.9385 12.1231 23.9385 12.0821 23.9385 12.0205 C 23.9385 11.959 23.9385 11.9179 23.9179 11.8564 C 23.9179 11.8154 23.8974 11.7744 23.8769 11.7538 C 23.8769 11.7333 23.8769 11.7128 23.8564 11.7128 C 23.8359 11.6718 23.8154 11.6308 23.7949 11.5897 C 23.7949 11.5897 23.7949 11.5692 23.7744 11.5692 C 23.7538 11.5282 23.7128 11.4872 23.6718 11.4462 L 18.1333 5.90769 C 17.8051 5.57949 17.2718 5.57949 16.9436 5.90769 C 16.6154 6.2359 16.6154 6.76923 16.9436 7.09744 L 21.0462 11.2 L 6.46154 11.2 C 5.98974 11.2 5.62051 11.5692 5.62051 12.041 C 5.62051 12.5128 5.98974 12.8821 6.46154 12.8821 L 21.0462 12.8821 L 16.9436 16.9846 C 16.6154 17.2718 16.6154 17.8051 16.9436 18.1333 Z"
                          ></path>
                          <path
                              id="Shape"
                              d="M 0.923077 23.8974 L 12 23.8974 C 12.4718 23.8974 12.841 23.5282 12.841 23.0564 L 12.841 14.7897 C 12.841 14.3179 12.4718 13.9487 12 13.9487 C 11.5282 13.9487 11.159 14.3179 11.159 14.7897 L 11.159 22.2154 L 1.7641 22.2154 L 1.7641 1.7641 L 11.159 1.7641 L 11.159 9.18974 C 11.159 9.66154 11.5282 10.0308 12 10.0308 C 12.4718 10.0308 12.841 9.66154 12.841 9.18974 L 12.841 0.923077 C 12.841 0.451282 12.4718 0.0820513 12 0.0820513 L 0.923077 0.0820513 C 0.451282 0.0820513 0.0820513 0.451282 0.0820513 0.923077 L 0.0820513 23.0564 C 0.102564 23.5282 0.471795 23.8974 0.923077 23.8974 Z"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
    <div v-if="brandInfo.currentBrand == 2" class="header-decor"><div class="header-decor__inner"><div class="header-decor--blue"></div><div class="header-decor--red"></div></div></div>
    <div class="menu-wrapper d-none d-md-block">
      <div class="container">
        <ul class="menu">
          <li v-if="availablePage" class="menu-item menu-item--drop-down">
            <a class="arrow-down">
              Каталог товаров
              <i class="arrow-down__child">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="9px"
                    height="5px"
                >
                  <path
                      fill-rule="evenodd"
                      fill="rgb(74, 74, 74)"
                      d="M7.950,-0.000 L4.500,3.108 L1.050,-0.000 L-0.000,0.946 L4.500,5.000 L9.000,0.946 L7.950,-0.000 Z"
                  />
                </svg>
              </i>
            </a>
            <div class="drop-down-container">
              <div class="drop-down-container__flex">
                <ul class="sub-menu" v-if="sectionsList">
                  <li
                      class="sub-menu__item"
                      v-for="item in sectionsList"
                      :key="item.name"
                  >
                    <router-link
                        class="sub-menu__item-link"
                        :to="/catalog/ + item.slug"
                    >{{ item.name }}</router-link
                    >
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <li class="menu-item menu-item--drop-down" v-if="brandInfo.currentBrand === 1">
            <a class="arrow-down">
              Каталог услуг
              <i class="arrow-down__child">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="9px"
                    height="5px"
                >
                  <path
                      fill-rule="evenodd"
                      fill="rgb(74, 74, 74)"
                      d="M7.950,-0.000 L4.500,3.108 L1.050,-0.000 L-0.000,0.946 L4.500,5.000 L9.000,0.946 L7.950,-0.000 Z"
                  />
                </svg>
              </i>
            </a>
            <div class="drop-down-container">
              <div class="drop-down-container__flex">
                <ul class="sub-menu">
                  <li class="sub-menu__item">
                    <static-page
                        title="Обучение"
                        class="sub-menu__item-link"
                        slug="/education"
                    />
                  </li>
                  <li v-if="availablePage" class="sub-menu__item">
                    <static-page
                        class="sub-menu__item-link"
                        type="4"
                        slug="/visits"
                    />
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <li class="menu-item">
            <static-page type="1" slug="/delivery" />
          </li>
          <li class="menu-item">
            <static-page type="2" slug="/how-to-order" />
          </li>
          <li class="menu-item">
            <router-link :to="{ name: 'Profile' }">Личный кабинет</router-link>
          </li>
          <li class="menu-item">
            <static-page type="3" slug="/about" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import "bootstrap/js/src/collapse";
import StaticPage from "../../components/static-pages/StaticPage";
import { mapGetters, mapActions } from "vuex";
import usersWithDisablePages from "@/config/users_with_disable_pages";
import store from "@/store";
import api from "@/api";
import router from "@/router";

export default {
  name: "DealerHeader",
  components: { StaticPage },
  async mounted() {
    await this.getUserInfo();
    await this.fetchSectionList();
    await this.fetchStaticList();
    await this.fetchCloseOrdersDealerByDate();

    if (this.brandInfo.brand == 3) {
      const brandToken = localStorage.getItem('brandToken');

      if (!brandToken) {
        this.openModal();
      }
    }
  },
  data: () => ({
    isModalOpen: false
  }),
  methods: {
    ...mapActions("account", ["getUserInfo"]),
    ...mapActions("catalog", ["fetchSectionList"]),
    ...mapActions("account", ["logout"]),
    ...mapActions("staticPages", ["fetchStaticList"]),
    ...mapActions('main_page', ['fetchPopularProducts']),
    ...mapActions("builtInParameter", ["fetchCloseOrdersDealerByDate"]),
    collapseMenu() {
      if (
          this.$refs.mobileMenu &&
          this.$refs.mobileMenu.classList.contains("show")
      )
        this.$refs.navbarToggler.click();
    },
    // Открытие модального окна
    openModal() {
      if (this.$refs.brandModal) {
        this.$refs.brandModal.showModal();
        this.disableBodyScroll();
        this.isModalOpen = true;
      }
    },
    // Закрытие модального окна
    closeModal() {
      if (this.$refs.brandModal) {
        this.$refs.brandModal.close();
        this.enableBodyScroll();
        this.isModalOpen = false;
      }
    },
    // Отключение скролла body
    disableBodyScroll() {
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = this.getScrollbarWidth() + 'px';
    },
    // Включение скролла body
    enableBodyScroll() {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    },
    // Получение ширины скроллбара
    getScrollbarWidth() {
      // Создаем временный элемент для измерения ширины скроллбара
      const outer = document.createElement('div');
      outer.style.visibility = 'hidden';
      outer.style.overflow = 'scroll';
      outer.style.msOverflowStyle = 'scrollbar';
      document.body.appendChild(outer);

      const inner = document.createElement('div');
      outer.appendChild(inner);

      const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

      // Удаляем временные элементы
      outer.parentNode.removeChild(outer);

      return scrollbarWidth;
    },
    // Обработка клика на backdrop
    handleBackdropClick(event) {
      // Если клик был именно на backdrop (сам dialog, а не его содержимое)
      if (event.target === this.$refs.brandModal) {
        this.closeModal();
      }
    },
    async switchDealerBrand(type) {
      const data = {"brand": Number(type)};

      try {
        const response = await api.dealerBrand.changeDealerBrand(data);
        if (response && response.data && response.data.data) {
          store.commit('account/SET_BRAND', response.data.data);

          await this.getUserInfo();
          await this.fetchSectionList();
          await this.fetchStaticList();
          await this.fetchCloseOrdersDealerByDate();
          await this.fetchPopularProducts();
          localStorage.setItem('brandToken', 1);
          this.closeModal();
          router.push({ name: "Home" });
        } else {
          console.error("switchDealerBrand err: could not get brand data");
          this.closeModal();
        }
      } catch (e) {
        console.error(e);
      }
    },
    // Получение названия текущего бренда для кнопки
    getAlternativeBrandName() {
      const currentBrand = this.brandInfo.currentBrand || 1;
      return currentBrand === 1 ? 'TEBOIL' : 'ЛУКОЙЛ';
    }
  },
  // Очистка при уничтожении компонента
  beforeUnmount() {
    if (this.isModalOpen) {
      this.enableBodyScroll();
    }
  },
  computed: {
    ...mapGetters("account", ["accountInfo", "pointsNumber", "brandInfo"]),
    ...mapGetters("cart", ["itemsInCart"]),
    ...mapGetters("catalog", ["sectionsList"]),
    ...mapGetters("staticPages", ["staticList"]),
    ...mapGetters("builtInParameter", ["closeOrdersDealerByDate"]),
    availablePage() {
      if (this.accountInfo.dealerUniqueId) {
        return !usersWithDisablePages.includes(
            +this.accountInfo.dealerUniqueId
        );
      }
      return true;
    },
  },
};
</script>

<style scoped>
.nav-wrapper {
  background: #000000;
}

.nav-wrapper .navbar-collapse .ml-auto {
  margin-left: 0!important;
}

.DealerHeader--lukoil .nav-wrapper {
  background: #000000;
}

.DealerHeader--teboil .nav-wrapper {
  background: #fff;
}

.DealerHeaderText--teboil {
  font-weight: 600;
  color: #000;
  text-align: left;
  font-size: 18px;
  display: block;
  max-width: 248px;
  margin-left: 8px;
}

.DealerHeaderText--lukoil {
  font-weight: 600;
  color: #fff;
  text-align: left;
  font-size: 18px;
  display: block;
  max-width: 248px;
  margin-left: 8px;
}

.header-logo-img {
  min-height: 42px;
}

.nav-wrapper nav {
  background: none;
  color: #ffffff;
}

.header-decor {
  overflow: hidden;
  width: 100%;
  max-width: 100%;
}

.header-decor__inner {
  position: relative;
  display: flex;
  flex-flow: row wrap;
  height: 20px;
  align-items: center;
  margin-left: -30px;
  margin-right: -30px;
}

.header-decor--blue {
  margin-right: 8px;
  background: #17489b;
  height: 100%;
  flex: 0 0 34.38%;
  max-width: 34.38%;
  -webkit-transform: skew(-15deg);
  -moz-transform: skew(-15deg);
  -o-transform: skew(-15deg);
}

.header-decor--red {
  background: #ee1732;
  height: 100%;
  flex: 1 1;
  max-width: 65%;
  -webkit-transform: skew(-15deg);
  -moz-transform: skew(-15deg);
  -o-transform: skew(-15deg);
}

nav .logo {
  width: 140px;
  height: auto;
}

.nav-item {
  margin-left: 28px;
}

.nav-item .nav-link {
  cursor: pointer;
  padding-left: 0;
  padding-right: 0;
}

.DealerHeader--teboil .nav-item .nav-link {
  svg {
    path {
      fill: #000;
    }
  }
}

.nav-item span {
  display: block;
  margin-top: 3px;
}

.nav-item span.ooo {
  font-size: 18px;
  line-height: 1;
  text-align: left;
  color: #ffffff;
}

.DealerHeader--teboil .nav-wrapper .nav-item span.ooo {
  color: #000;
}

.nav-item span.coins {
  font-size: 18px;
  line-height: 1;
  text-align: left;
  color: #e5173f;
}

.bag a {
  position: relative;
}

.bag a:after {
  content: attr(data-count);
  position: absolute;
  top: 5px;
  right: -13px;
  background-color: #e5173f;
  width: 19px;
  height: 19px;
  border-radius: 50%;
  font-size: 10px;
  font-weight: bold;
  color: #fff;
  display: block;
  text-align: center;
  line-height: 1.8;
}

.menu-wrapper {
  display: flex;
  background-color: #eff1f6;
  padding: 5px 0;
}

.menu {
  list-style: none;
  display: flex;
  justify-content: space-between;
  margin: 0;
  padding: 0;
}

.menu-item {
  padding: 0 20px;
}

.menu-item a {
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #4a4a4a;
  padding: 11px 0;
  display: block;
  box-sizing: border-box;
  position: relative;
  text-decoration: none;
}

.menu-item a.active:after {
  content: "";
  display: block;
  width: 100%;
  height: 2px;
  background-color: #e5173f;
  position: absolute;
  bottom: 0;
  left: 0;
}

.menu-item a:not(.active):hover::after {
  content: "";
  display: block;
  width: 100%;
  height: 2px;
  background-color: rgba(229, 23, 63, 0.44);
  position: absolute;
  bottom: -4px;
}

.menu-item:last-child {
  padding-right: 0;
}

.menu-item:first-child {
  padding-left: 0;
}

/* Стили для кнопки переключения бренда */
.brand-switcher {
  margin-left: 0;
  margin-right: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
}

.brand-switcher-button {
  background: #e5173f;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s;
}

.brand-switcher-logo-btn {
  height: 38px;
  background: transparent;
  cursor: pointer;
  padding: 4px 2px;
  border-radius: 2px;
  border: none;
  overflow: hidden;
  outline: none;
}

.brand-switcher-logo-btn--lukoil {
  background: transparent;
  padding: 4px 2px;
}

.brand-switcher-logo-btn--teboil {
  background: #e73331;
}

brand-switcher-logo-btn:focus {
  outline: none;
  border: none;
}

brand-switcher-logo-btn:active {
  outline: none;
  border: none;
}

.brand-switcher-logo-btn img {
  max-height: 100%;
  width: auto;
}

.brand-switcher-button:hover {
  background: #c41435;
}

.brand-switcher-button:active {
  color: #fff!important;
}

.brand-switcher-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 14px;
}

.brand-switcher-wrapper-title {
  font-weight: 600;
  font-size: 16px;
}

.brand-switcher-wrapper-title--lukoil {
  color: #000;
}

.brand-switcher-wrapper-title--teboil {
  color: #fff;
}

  /* Стили для модального окна */
.brand-modal {
  border: none;
  border-radius: 0;
  padding: 0;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
}

.brand-modal:not([open]) {
  display: none;
}

.brand-modal::backdrop {
  background: rgba(0, 0, 0, 0.5);
}

.modal-content {
  padding: 0;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 20px 10px 20px;
  background: #f8f9fa;
  border-radius: 0;
}

.modal-header h3 {
  margin: 0;
  color: #333;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-button:hover {
  color: #333;
}

.modal-body {
  padding: 30px 20px;
}

.switch-dealer-type {
  display: flex;
  flex-flow: row;
  gap: 15px;
  justify-content: space-between;
}

.brand-button {
  background: transparent;
  color: white;
  border: none;
  padding: 0;
  border-radius: 6px;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
  min-width: 160px;
  width: 100%;
  max-width: 160px;
  height: 60px;
  overflow: hidden;
}

.brand-button img {
  width: 100%;
  height: 100%;
}

.brand-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

@media (min-width: 577px) and (max-width: 991px) {
  .navbar {
    flex-wrap: inherit;
    align-items: flex-start;
    padding: 0.5rem 0.3rem;
  }

  .navbar-nav {
    flex-direction: row;
    justify-content: space-around;
  }

  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
}

@media (max-width: 767px) {
  nav .logo {
    width: 100px;
    padding-top: 4px;
  }

  .navbar {
    flex-wrap: inherit;
    align-items: flex-start;
    padding: 0.6rem;
  }

  .flex-end-sm {
    justify-content: flex-end;
  }

  .navbar-nav {
    flex-direction: row;
    justify-content: space-around;
  }

  .nav-item {
    margin-left: 15px;
  }

  .nav-item svg {
    width: 20px;
    height: 20px;
  }

  .nav-item span {
    font-size: 12px;
  }

  .navbar-brand {
    padding-top: 0;
    padding-left: 15px;
  }

  #navbarNavDropdown {
    position: absolute;
    top: 100%;
    width: 100%;
    z-index: 10;
    margin: 0 -0.3rem;
    background-color: #eff1f6;
    box-shadow: 0 5px 6px 0 rgba(0, 0, 0, 0.2);
  }

  .navbar-toggler .icon-bar {
    display: block;
    width: 22px;
    height: 2px;
    border-radius: 1px;
    margin-top: 5px;
    background-color: #fff;
  }

  .DealerHeader--teboil .navbar-toggler .icon-bar {
    background-color: #000;
  }

  .navbar-toggler[aria-expanded="true"]:before {
    content: "";
    width: 50px;
    height: 55px;
    display: block;
    background: #eff1f6;
    position: absolute;
    left: -5px;
    top: -8px;
    z-index: 0;
  }

  .navbar-toggler[aria-expanded="true"] .icon-bar {
    position: relative;
    z-index: 2;
    background-color: black;
  }

  .navbar-toggler {
    padding: 0.25rem 0.55rem;
    position: relative;
    background-color: transparent;
    border: none;
  }

  .navbar-toggler:focus {
    outline: none;
  }

  .menu-mobile {
    list-style: none;
    padding: 0px;
    margin: 20px 0;
  }

  .menu-mobile .menu-item a {
    text-align: left;
    padding: 15px 40px;
  }

  .menu-mobile .menu-item a.active {
    background-color: #b3b3b3;
  }

  .menu-mobile .menu-item a:hover {
    background-color: #eaeaea;
  }

  .menu-mobile .menu-item a:after {
    content: "";
    display: none;
  }

  .menu-mobile .menu-item {
    padding: 0;
  }

  .navbar-nav.ml-auto li:first-child {
    padding-top: 3px;
  }

  /* Адаптивные стили для модального окна */
  .brand-modal {
    width: 95%;
    margin: 10px;
  }

  .switch-dealer-type {
    flex-direction: column;
    align-items: center;
  }

  .brand-button {
    width: 100%;
    max-width: 200px;
  }

  .brand-switcher {
    margin-right: 0;
    margin-left: auto;
    display: flex;
    justify-content: flex-end;
    padding-top: 12px;
    order: 5;
  }

  .brand-switcher-button {
    padding: 6px 12px;
    font-size: 14px;
  }

  .navbar-collapse {
    display: flex;
    flex-flow: column;
    justify-content: flex-end;
  }

  .nav-wrapper .navbar-collapse .ml-auto {
    margin-left: auto!important;
  }
}

@media (max-width: 380px) {
  .nav-item {
    margin: 0 20px;
  }

  .nav-item:first-child {
    display: none;
  }
}

.menu-mobile .menu-item a:hover {
  background-color: #eff1f6;
}

a .itemsTooltip,
a .logoutTooltip {
  visibility: hidden;
  width: 20px;
  font-family: "Arial", Arial, sans-serif;
  font-size: 14px;
  color: #fff;
  text-align: center;
  margin-top: 30px;
  margin-left: -25px;
  position: absolute;
}

.DealerHeader--teboil a .itemsTooltip,
.DealerHeader--teboil a .logoutTooltip {
  color: #000;
}


a:hover .itemsTooltip,
a:hover .logoutTooltip {
  visibility: visible;
}

.menu-item--drop-down,
.arrow-down {
  position: relative;
  top: 0;
  left: 0;
}

.menu-item--drop-down {
  z-index: 100;
  cursor: pointer;
}

.menu-item--drop-down:nth-of-type(2) .drop-down-container {
  left: -20px;
}

.arrow-down__child {
  position: absolute;
  top: 9px;
  right: -22px;
}

.drop-down-container {
  display: block;
  position: absolute;
  top: 35px;
  left: -45px;
  width: 100%;
}

.drop-down-container__flex {
  display: block;
  width: 300px;
  padding-bottom: 20px;
  background: #eff1f6;
  box-shadow: 0 39px 67px -49px rgba(0, 0, 0, 0.53);
}

.menu-item--drop-down:nth-of-type(2) .drop-down-container {
  box-shadow: 0 40px 44px -23px rgba(0, 0, 0, 0.33);
}

.drop-down-container {
  display: none;
}

.menu-item--drop-down:hover .drop-down-container {
  display: block;
}

.sub-menu {
  display: block;
  margin: 0;
  list-style: none;
  width: 100%;
  padding: 7px 24px;
}

.sub-menu__item {
  border-bottom: solid #dfdfdf 1px;
}

.sub-menu__item:last-child {
  border-bottom: solid transparent 1px;
}

.sub-menu__item-link {
  display: block;
  text-align: left;
  padding: 20px 20px;
  transition: background 0.2s linear, color 0.2s linear;
}

.sub-menu__item-link:hover {
  background: #d2233c;
  color: #fff;
}

.sub-menu__item-link:hover:after {
  display: none;
}

@media only screen and (max-width: 991px) {
  .drop-down-container {
    top: 58px;
  }
}

.g-hide {
  display: none;
}
</style>